// removed by extract-text-webpack-plugin
module.exports = {"root":"ModalInMobile__root__3nAMl","modalHidden":"ModalInMobile__modalHidden__2SWPt","modalContainer":"ModalInMobile__modalContainer__2XB7o","modalContent":"ModalInMobile__modalContent__2Emvo"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ModalInMobile/ModalInMobile.css
// module id = 2039
// module chunks = 0